import { TranslationsContext } from '@telia-common-components/shared';
import React, { useContext } from 'react';
import { Card, CardContent, Grid, GridColumn, Heading, Icon, Notice, Separator } from 'telia-front-react';
export const NetflixAppViewRequirements = () => {
    const { translate } = useContext(TranslationsContext);
    const viewRequirements = [
        {
            icon: 'service-internet',
            text: translate('netflixModal.viewRequirements.speed'),
        },
        {
            icon: 'tv-screen',
            text: translate('netflixModal.viewRequirements.tv'),
        },
    ];
    return (React.createElement(Card, { padding: "medium", type: "light", background: "transparent" },
        React.createElement(CardContent, { borderRadius: "medium" },
            React.createElement(Heading, { level: 2, className: "h4 text-bold" }, translate('netflixModal.viewRequirements.title')),
            React.createElement(Separator, { color: "invisible", spacing: "small" }),
            viewRequirements.map((section, sectionIndex) => (React.createElement(React.Fragment, { key: sectionIndex },
                React.createElement(Grid, { horizontalGutter: "smedium", verticalGutter: "none", noWrap: true, gutter: "small" },
                    React.createElement(GridColumn, { width: ['min-xs'], align: ['middle-xs'] },
                        React.createElement(Icon, { modifiers: `#${section.icon}`, size: "sm" })),
                    React.createElement(GridColumn, { width: ['max-xs'] }, section.text)),
                React.createElement(Separator, { color: "invisible", spacing: "xsmall" })))),
            React.createElement(Notice, { size: "small", type: "attention" }, translate('netflixModal.notice.device')))));
};
